export const SPECIAL_ERROR_CODES = {
    ASSIGN_OWNER: 'ASSIGN_NEW_TEAM_OWNER',
};